<script setup lang="ts">
import Message from 'primevue/message';
import { computed } from 'vue';
import type { ProblemDetails } from "shared/problems/domain/problemDetails";

const model = defineModel<ProblemDetails>();
  const errors = computed(() => {
  const result: string[] = [];
  const details = model.value;
  if (!details || !details.errors) return result;
  const items = details.errors;
  for (const [key, value] of Object.entries(items)) {
    result.push(...value);
  }
  return result;
});

</script>

<template>
  <Message class="problem-details" v-if="model" severity="error">
  {{ model.title }}
  <div class="error-item" v-for="error in errors">{{ error }}</div>
</Message>
</template>

<style scoped>

  .error-item {
    font-size: 12px;
  }

  .problem-details {
    margin-top: 1px;
    margin-bottom: 0.5rem;
  }

</style>
